// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1RGWbRrnRqYAJnUwQJZBIX","tree":"O9iwa4YJYFS2ckruzmLvY","space":"_1L103oyajNEF5B-sdMdsC6"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Tree/styles.scss
 ** module id = 476
 ** module chunks = 0
 **/